import { useTranslation } from 'react-i18next'

import EditWidgetForm from './EditWidgetForm'
import Widget from '../Widget'

export const useAVERAGE_EVENTS_AMOUNT_BY_PERIOD_CONFIG = () => {
  const { t } = useTranslation('common')

  return {
    id: 'AVERAGE_EVENTS_AMOUNT_BY_PERIOD',
    name: t('widgets.averageEventsAmountByPeriod.name'),
    description: t('widgets.averageEventsAmountByPeriod.description'),
    color: 'darkGreen',
    icon: 'RiBarChartHorizontalFill',
    categories: [t('widgets.averageEventsAmountByPeriod.category')],
    previewWidth: '65%',

    initialState: {
      size: { width: 50, height: 400 },
      data: { periodType: 'day_of_week' }
    },

    Presentation: Widget,
    Form: EditWidgetForm
  }
}
